import { languageMap } from "../core"
import { bracketIndenting } from "./shared"

languageMap.ada = bracketIndenting({ line: "--" })
